import React, { memo, useMemo } from "react"
import { css } from "@emotion/react"
import { withCssUnit } from "@ncs/ts-utils"
import { ncsBlue, ncsWhite } from "../images/logos"

export type LogoNames = "ncs" | "ncsWhite"

export interface LogoProps {
	company?: LogoNames
	maxWidth?: string | number
	/** Set either width or height, but not both. */
	width?: string | number
	/** Set either width or height, but not both. */
	height?: string | number
}

export const Logo: React.FC<LogoProps> = memo(({ company = "ncs", maxWidth, width, height }) => {
	if (!!width && !!height) {
		throw new Error(
			"Logo component is intended to be passed either a width or a height, but not both"
		)
	}

	const logoSrc = useMemo(() => {
		switch (company) {
			case "ncsWhite":
				return ncsWhite
			case "ncs":
			default:
				return ncsBlue
		}
	}, [company])

	const style = useMemo(() => {
		return css`
			display: inline-block;
			max-width: ${maxWidth != null ? withCssUnit(maxWidth) : "none"};
			width: ${withCssUnit(width)};
			height: ${withCssUnit(height)};
			img {
				${width && "height: auto; width: 100%;"}
				${height && "width: auto; height: 100%;"}
			}
		`
	}, [width, maxWidth, height])

	return (
		<div css={style}>
			<img src={logoSrc} alt={`${company} logo`} />
		</div>
	)
})
